module.exports = __webpack_public_path__ + "img/director-test-icon1.4a34f0e7.png";